// localize the requires here
/* eslint-disable @typescript-eslint/no-var-requires, @typescript-eslint/no-require-imports */

// suggestions
export const suggestionColorsBg: string = require("./suggestion-card-colors.svg");
export const suggestionPersonalCalendarSyncBg: string = require("./suggestion-card-personal-calendar-sync.svg");
export const suggestionSetUpTeamBg: string = require("./suggestion-card-set-up-team_2X.gif");
export const suggestionShadowCalendarBg: string = require("./suggestion-card-shadow-calendar.svg");
export const suggestionSlackEnhancedBg: string = require("./suggestion-card-slack-enhanced.svg");
export const suggestionTravelTimeBg: string = require("./suggestion-card-travel-time.png");

// onboarding
export const meetingMove: string = require("./meeting-move.svg");

export const chromeProductOnboardingMeetingHours: string = require("./chrome-product-onboarding-meeting-hours.svg");
export const chromeProductOnboardingTeam: string = require("./chrome-product-onboarding-team.svg");

export const onboardingAutopilotCarouselSlide1: string = require("./onboarding-autopilot-carousel-1.svg");
export const onboardingAutopilotCarouselSlide2: string = require("./onboarding-autopilot-carousel-2.svg");
export const onboardingAutopilotCarouselSlide3: string = require("./onboarding-autopilot-carousel-3.svg");
export const onboardingAutopilotCarouselSlide4: string = require("./onboarding-autopilot-carousel-4.svg");

export const onboardingAutopilotConfirmation: string = require("./onboarding-autopilot-confirmation.svg");
export const onboardingIntro: string = require("./onboarding-intro-illustration.png");
export const clockwiseBeforeAfter: string = require("./clockwise-before-after.svg");
export const onboardingFocusTimeOff: string = require("./onboarding-focus-time-off.svg");
export const onboardingFocusTimeOn: string = require("./onboarding-focus-time-on.svg");
export const onboardingInvite: string = require("./onboarding-invite.svg");
export const onboardingLunch: string = require("./onboarding-lunch.svg");
export const onboardingSurvey: string = require("./onboarding-survey.svg");

// Illustrations for Asana
export const cwAsanaFocusTime: string = require("./cw_asana_focustime.svg");
export const cwAsanaEffective: string = require("./cw_asana_effective.svg");
export const cwAsanaAddToGCal: string = require("./cw_asana_add_to_gcal.svg");

// smart agendas
export const smartAgendaInstallChromeExtension: string = require("./smart-agenda-install-chrome-extension.svg");

// other
export const confettiPng: string = require("./confetti.png");
export const lightBulb: string = require("./lightbulb.svg");
export const weekInReviewGif: string = require("./week-in-review.gif");
export const personWorkingUnderCalendar: string = require("./person-working-under-calendar.png");
export const oneOnOneColumnsViewEmpty: string = require("./one-on-one-empty-state.svg");

// downtime
export const clockwiseNotFoundHero: string = require("./clockwise-not-found-hero.svg");

// old-illos in general
export const constructionBlockSvg: string = require("./old/construction-block.svg");

// login
export const defragGif: string = require("./defrag.gif");

// teams
export const teamsSvg: string = require("./teams.svg");
export const onboardingTeamsIllustration: string = require("./onboarding-teams-illustration.svg");

// illustrations
export const personWorkingOnSofaInFrontOfCalendar: string = require("./person-working-on-sofa-in-front-of-calendar.svg");
export const peopleWorkingOnSofaInFrontOfCalendar: string = require("./people-working-on-sofa-in-front-of-calendar.svg");

export const brokenClock: string = require("./broken-clock.svg");

// partner integrations
export const aclackaTasksInFocusTime: string = require("./aclacka-tasks-in-focus-time.png");

// links
export const schedulingLink404: string = require("./scheduling-link-404.svg");
